import { withNamespace } from "components/Form/FormikControls";
import {
  TransactionalSaleFormTabId,
  TransactionalSaleFormTabs,
} from "../constants";
import { FormStatus } from "constants/form";
import theme from "constants/theme";

export const getTabFields = (
  saleLotNamespace: string,
  consignmentNamespace?: string,
  saleNamespace?: string,
): Record<TransactionalSaleFormTabId, string[]> => ({
  [TransactionalSaleFormTabs.WHO]: [
    ...(consignmentNamespace
      ? [
          withNamespace(consignmentNamespace, "vendor_id"),
          withNamespace(consignmentNamespace, "carrierCharge.carrier"),
        ]
      : [withNamespace(saleLotNamespace, "consignment_id")]),
    withNamespace(saleLotNamespace, "buyer_id"),
  ],
  [TransactionalSaleFormTabs.WHAT]: saleNamespace
    ? [
        "saleLots",
        ...(consignmentNamespace
          ? [
              withNamespace(
                consignmentNamespace,
                "carrierCharge.invoiceNumber",
              ),
              withNamespace(
                consignmentNamespace,
                "carrierCharge.invoiceAmount",
              ),
            ]
          : []),
      ]
    : [
        withNamespace(saleLotNamespace, "quantity"),
        withNamespace(saleLotNamespace, "product_id"),
        withNamespace(saleLotNamespace, "sex_id"),
        withNamespace(saleLotNamespace, "age_id"),
        withNamespace(saleLotNamespace, "breed_id"),
        withNamespace(saleLotNamespace, "quantity_progeny"),
        withNamespace(saleLotNamespace, "dentitionId"),
        withNamespace(saleLotNamespace, "draftingAttributes.tagNumber"),
        withNamespace(saleLotNamespace, "draftingAttributes.animalName"),
        withNamespace(saleLotNamespace, "marks"),
        withNamespace(saleLotNamespace, "labels"),
        withNamespace(saleLotNamespace, "category_id"),
        withNamespace(saleLotNamespace, "note"),
      ],
  [TransactionalSaleFormTabs.WHEN]: saleNamespace
    ? [
        withNamespace(saleNamespace, "date"),
        ...(consignmentNamespace
          ? [
              withNamespace(consignmentNamespace, "carrierCharge.deliveryDate"),
              withNamespace(consignmentNamespace, "carrierCharge.notes"),
            ]
          : []),
      ]
    : [],
  [TransactionalSaleFormTabs.PRICE]: [
    withNamespace(saleLotNamespace, "pricing_type_id"),
    withNamespace(saleLotNamespace, "unit_price"),
  ],
  [TransactionalSaleFormTabs.NLIS]: [
    withNamespace(saleLotNamespace, "quantityTagsUsed"),
  ],
  [TransactionalSaleFormTabs.REVIEW]: [],
});

export const getTabStatusColor = (tabStatus: string | undefined) => {
  switch (tabStatus) {
    case FormStatus.ERROR:
      return theme.colors.error;
    case FormStatus.TOUCHED:
      return theme.colors.successGreen;
    case FormStatus.UNTOUCHED:
      return theme.colors.gray78;
    default:
      return null;
  }
};
